import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CarrierAddressItem } from 'src/models/DTO/carrier/carrierAddressItem';
import { Config } from '../../../infrastructure/config';
import { SpeedyOffice } from 'src/models/DTO/carrier/speedyOffice';

@Injectable({
  providedIn: 'root'
})
export class SpeedyService {

  private carrierSearchURL: string = Config.api + 'carrier/address/search';
  private carrierOfficeSearchURL: string = Config.api + 'carrier/address/search/office';

  constructor(private httpClient: HttpClient) { }

  searchCarrierCountries(searchString: string) {
    return this.httpClient.get<CarrierAddressItem>(this.carrierSearchURL + '/country/' + encodeURIComponent(searchString));
  }

  searchCarrierCity(countryKey: number, searchString: string) {
    return this.httpClient.get<CarrierAddressItem>(
      this.carrierSearchURL + '/city/' + countryKey + '/' + encodeURIComponent(searchString)
    );
  }

  searchCarrierOffice(cityKey: number, searchString: string) {
    return this.httpClient.get<CarrierAddressItem>(
      this.carrierSearchURL + '/street/' + cityKey + '/' + encodeURIComponent(searchString)
    );
  }

  searchCarrierPickUpOffice(siteId: string, query: string = '') {
    let params = new HttpParams()
      .set('countryId', '100')
      .set('siteId', siteId);

    if (query.trim()) {
      params = params.set('name', query.trim());
    }

    return this.httpClient.get<SpeedyOffice>(this.carrierOfficeSearchURL, { params });
  }
}
